import { render, staticRenderFns } from "./associ.vue?vue&type=template&id=0f3b108d&scoped=true&"
import script from "./associ.vue?vue&type=script&lang=js&"
export * from "./associ.vue?vue&type=script&lang=js&"
import style0 from "./associ.vue?vue&type=style&index=0&id=0f3b108d&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3b108d",
  null
  
)

export default component.exports